










import ContactBlock from '@/components/ContactBlock'
import FormSchema from '@/components/FormSchema'

export default {
    name: 'ContactForm'

    props: ['document']

    components:
        ContactBlock: ContactBlock
        FormSchema: FormSchema

    computed:
        isDark: -> @$parent.isDark

    data: ->
        fields: @defaultFields()

    methods:
        defaultFields: ->
            contact_block: []
            form_schema: []

        setContent: (document) ->
            fields =
                contact_block: document.primary.contact_block
                form_schema: document.primary.form_schema
            $.extend @fields, fields

    created: ->
        @setContent @document
}
